import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackClickEvent } from '@src/telemetry/track'

type TrackingMetaData = {
  context: string
}

type TrackEventProps = {
  tracker?: string
  trackingMetaData?: TrackingMetaData
  onClick?: (event: { direction: string }) => void
}

export const useTrackEvents = (props: TrackEventProps) => {
  const trackEvent = (type: string) => {
    if (props.tracker) {
      trackClickEvent(TELEMETRY_EVENT_NAMES.BUTTON_CLICK, {
        trackGA: true,
        trackInternal: true,
        category: 'navigation',
        action: type === 'next' ? 'click_carousel_right' : 'click_carousel_left',
        value: props.tracker,
        context: props.trackingMetaData?.context,
      })
    }

    if (props.onClick) {
      props.onClick({ direction: type })
    }
  }

  return {
    trackNext: () => trackEvent('next'),
    trackPrev: () => trackEvent('prev'),
  }
}
